import { useTranslation } from 'react-i18next'

import { OfferStatus } from '@wwt/entities/api/search-response'
import { statusColorsAsCSSVariables } from '@wwt/shared/config/statusColors'

import { cn } from '@/shared/lib/cn'

interface OfferStatusBadgeProps {
	status: keyof typeof OfferStatus
	className?: string
}

export const OfferStatusBadge = ({
	status,
	className
}: OfferStatusBadgeProps) => {
	const { t } = useTranslation()

	return (
		<div
			className={cn(
				'flex h-8 items-center justify-center rounded-md bg-(--background) max-md:mx-5 lg:mb-5',
				className
			)}
			style={
				{
					'--background': `var(${statusColorsAsCSSVariables[status]})`
				} as React.CSSProperties
			}
		>
			{t(`statues.${status}`)}
		</div>
	)
}
